/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_ButtonInputs */

const ja_home_brands_button = /** @type {(inputs: Home_Brands_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINの実績を見る`)
};

const en_home_brands_button = /** @type {(inputs: Home_Brands_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXPLORE OUR WORK`)
};

/**
* | output |
* | --- |
* | "EXPLORE OUR WORK" |
*
* @param {Home_Brands_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_button = /** @type {((inputs?: Home_Brands_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_button(inputs)
	return en_home_brands_button(inputs)
});